"use strict";
exports.__esModule = true;
exports.init = void 0;
var tslib_1 = require("tslib");
var isomorphic_fetch_1 = tslib_1.__importDefault(require("isomorphic-fetch"));
var routes_1 = require("../../api/routes");
var apiHost;
var init = function (hostname) {
    apiHost = hostname;
    return {
        fetchTrackedSessions: fetchTrackedSessions,
        createTrackedSession: createTrackedSession
    };
};
exports.init = init;
var fetchTrackedSessions = function (providerId) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var url, result, e_1;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "" + apiHost + routes_1.routes.serviceDelivery.list + "?providerId=" + providerId;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, isomorphic_fetch_1["default"](url)];
            case 2:
                result = _a.sent();
                return [2 /*return*/, result.json()];
            case 3:
                e_1 = _a.sent();
                throw new Error("Could not fetch tracked sessions - " + e_1.message);
            case 4: return [2 /*return*/];
        }
    });
}); };
var createTrackedSession = function (session) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var url, body, headers, result, e_2;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "" + apiHost + routes_1.routes.serviceDelivery.track;
                body = JSON.stringify(session);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                headers = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: body
                };
                return [4 /*yield*/, isomorphic_fetch_1["default"](url, headers)];
            case 2:
                result = _a.sent();
                if (result.status !== 201) {
                    throw new Error(result.statusText);
                }
                return [2 /*return*/, result.json()];
            case 3:
                e_2 = _a.sent();
                throw new Error("Could not create tracked session - " + e_2.message);
            case 4: return [2 /*return*/];
        }
    });
}); };
//# sourceMappingURL=index.js.map